/**
 * Common Queries
 *
 * Frequently used queries for common security exposures and risks.
 * These queries are useful across all customer environments.
 */

import type { SavedQuery } from '@/sections/insights/queryBuilder/types/SavedQuery';

import { QueryFolders } from './folders';

export const COMMON_QUERIES: SavedQuery[] = [
  {
    id: 'demonstrated-critical-risks',
    name: 'Demonstrated Critical Risks',
    type: 'table',
    description:
      'Display all critical-severity risks that have been Demonstrated.',
    folderId: QueryFolders.COMMON_QUERIES,
    query: {
      node: {
        labels: ['Risk'],
        filters: [
          {
            field: 'status',
            operator: '=',
            value: 'OC',
          },
        ],
      },
      limit: 1000,
    },
  },
  {
    id: 'detected-critical-risks',
    name: 'Detected Critical Risks',
    type: 'table',
    description: 'Display all critical-severity risks that have been Detected.',
    folderId: QueryFolders.COMMON_QUERIES,
    query: {
      node: {
        labels: ['Risk'],
        filters: [
          {
            field: 'status',
            operator: '=',
            value: 'TC',
          },
        ],
      },
      limit: 1000,
    },
  },
  {
    id: 'resolved-critical-risks',
    name: 'Resolved Critical Risks',
    type: 'table',
    description: 'Display all critical-severity risks that have been Resolved.',
    folderId: QueryFolders.COMMON_QUERIES,
    query: {
      node: {
        labels: ['Risk'],
        filters: [
          {
            field: 'status',
            operator: '=',
            value: 'RC',
          },
        ],
      },
      limit: 1000,
    },
  },
];
